import { FlowDurationSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../../base/baseSchema.js';

export const WaitBlockV2ConfigSchema = z
  .object({
    duration: FlowDurationSchema.optional(),
    waitUntilDate: z.string().optional(),
  })
  .refine(
    (obj) => {
      // We only allow one of these fields, (XOR):
      return Boolean(obj.duration) !== Boolean(obj.waitUntilDate);
    },
    {
      message:
        'Either pre-defined duration or dynamic duration/target datetime must be provided (but not both)',
      path: ['duration', 'waitUntilDate'],
    }
  );
export type WaitBlockV2Config = z.infer<typeof WaitBlockV2ConfigSchema>;

export const WaitBlockV2Schema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.WaitV2),
  config: WaitBlockV2ConfigSchema,
});
export type WaitBlockV2 = z.infer<typeof WaitBlockV2Schema>;
